<template>
  <DragDialog
    class="inner-pop-primary"
    title="异常状态"
    :width="800"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="queue-list-box">
      <div v-if="tableLoading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)"
        />
      </div>
      <div class="common-table-box" v-else>
        <el-table
          class="publish-small-table publish-table"
          highlight-selection-row
          height="100%"
          :data="dataList"
        >
          <el-table-column label="序号" type="index" width="75" />
          <el-table-column label="文件名">
            <template v-slot="{ row }">
              <span>{{ row.name ? row.name : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数据类型">
            <template v-slot="{ row }">
              <span>{{ getDataSetType(row.dataSetType) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="异常原因">
            <template v-slot="{ row }">
              <span v-if="row.exceptionType === 0">文件已删除</span>
              <span v-if="row.exceptionType === 1">坐标不一致</span>
              <span v-if="row.exceptionType === 2">转换失败</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="row.exceptionType === 2"
                  type="text"
                  size="small"
                  @click="reConvert(row)"
                >
                  重试
                </el-button>
                <el-button type="text" size="small" @click="deleteData(row)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page"
              >
                <template slot="description">
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import Spin from "@/components/Spin.vue";

import {
  getExceptionListService,
  cadRetryService,
  vectorRetryService,
  deleteSingleSceneTreeNode,
} from "@/service/interface";

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
    };
  },
  props: {
    visible: Boolean,
    updateSceneTreeStatus: Function,
    updateSceneTree: Function,
    openConvertQueue: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    Spin,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initDataList();
      }
    },
  },
  methods: {
    initDataList() {
      this.tableLoading = true;

      this.queryDataList().then((dataList) => {
        this.dataList = dataList;

        this.tableLoading = false;
      });
    },
    reConvert(data) {
      let dataSetType = data.dataSetType;
      let treeNodeId = data.treeNodeId;
      if (dataSetType === 21) {
        cadRetryService(treeNodeId).then((response) => {
          if (response.isSuccess) {
            this.openConvertQueue();
            this.updateSceneTreeStatus([data.dataSetId]);
            this.$message.success("重新转换");
          } else {
            this.$message.error(response.errMsg);
          }
        });
      } else {
        vectorRetryService(treeNodeId).then((response) => {
          if (response.isSuccess) {
            this.openConvertQueue();
            this.updateSceneTreeStatus([data.dataSetId]);
            this.$message.success("重新转换");
          } else {
            this.$message.error(response.errMsg);
          }
        });
      }
    },
    deleteData(data) {
      let params = { nodeIds: [data.treeNodeId] };
      deleteSingleSceneTreeNode(params).then((response) => {
        if (response.isSuccess) {
          this.updateSceneTree().then(() => {
            this.refreshDataList();

            this.$message.success("删除成功");
          });
        }
      });
    },
    refreshDataList() {
      this.queryDataList().then((dataList) => {
        this.dataList = dataList;
      });
    },
    queryDataList() {
      return new Promise((resolve) => {
        let sceneId = this.$route.query.sceneId;
        let params = { sceneId };
        getExceptionListService({ params }).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let dataList = data.items;
            resolve(dataList);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    getDataSetType(dataSetType) {
      const dataSetTypeMapArray = [
        { value: 0, label: "BIM模型" },
        { value: 10, label: "Wmts地图服务" },
        { value: 11, label: "倾斜摄影" },
        { value: 13, label: "遥感影像" },
        { value: 15, label: "点云" },
        { value: 21, label: "二维图纸" },
        { value: 22, label: "矢量数据" },
      ];
      let find = dataSetTypeMapArray.find((el) => el.value === dataSetType);
      return find.label;
    },
    cancel() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.queue-list-box {
  height: 500px;

  .common-table-box {
    height: 100%;

    .common-button-box {
      display: flex;
    }
  }
}
</style>